import { render, staticRenderFns } from "./AdminActionLogsList.vue?vue&type=template&id=5f357e25&scoped=true"
import script from "./AdminActionLogsList.vue?vue&type=script&lang=js"
export * from "./AdminActionLogsList.vue?vue&type=script&lang=js"
import style0 from "./AdminActionLogsList.vue?vue&type=style&index=0&id=5f357e25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f357e25",
  null
  
)

export default component.exports